/* DymoOnline — small DOM patches
 *
 * Loaded on every page from the header-group loader, after dymo-fixes.css.
 * Anything here is a fix that cannot be expressed in CSS alone.
 */
(function () {
  "use strict";

  if (window.__dymoFixes) return;
  window.__dymoFixes = 1;

  var SHIPPING_URL = "/pages/shipping-returns";

  /* -------------------------------------------------------------------------
   * "(conditions apply)" in the cart free-shipping message
   *
   * The cart drawer tells the customer "You are eligible for free shipping
   * (conditions apply)." but never says what the conditions are. Turn that
   * phrase into a link to the shipping policy. The string comes from a locale
   * file and is rendered as plain text, so it has to be linked here.
   *
   * Only bare text nodes are touched, and each is done once, so re-rendering
   * the drawer cannot produce nested links.
   * ---------------------------------------------------------------------- */
  function linkConditions(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || node.nodeValue.indexOf("conditions apply") === -1) {
          return NodeFilter.FILTER_REJECT;
        }
        // already linked, or inside a link
        if (node.parentNode && node.parentNode.closest("a")) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var targets = [], n;
    while ((n = walker.nextNode())) targets.push(n);

    targets.forEach(function (node) {
      var text = node.nodeValue;
      var idx = text.indexOf("conditions apply");
      if (idx === -1) return;

      var before = document.createTextNode(text.slice(0, idx));
      var link = document.createElement("a");
      link.href = SHIPPING_URL;
      link.textContent = "conditions apply";
      link.className = "dymo-conditions-link";
      link.style.color = "inherit";
      link.style.textDecoration = "underline";
      link.style.textUnderlineOffset = "2px";
      var after = document.createTextNode(text.slice(idx + "conditions apply".length));

      var parent = node.parentNode;
      parent.insertBefore(before, node);
      parent.insertBefore(link, node);
      parent.insertBefore(after, node);
      parent.removeChild(node);
    });
  }

  function start() {
    linkConditions(document.body);

    if (!window.MutationObserver) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { linkConditions(document.body); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
